export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.397 4.202a1 1 0 01.877-.164l14 4A1 1 0 0123 9v11a1 1 0 01-1 1H2a1 1 0 01-1-1v-6a1 1 0 01.445-.832L7 9.465V5c0-.313.147-.61.397-.798zM9 19h12V9.754L9 6.326V19zm-6-4.464V19h4v-7.132l-4 2.668z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};